import { useCallback, useEffect, useState } from 'react';
import { useAppContext } from '../../AppContext';
import { User } from '../../models/User';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useUpdateUser(disableAlertOnError?: boolean) {
  const { logError } = useAppContext();
  const { loading: updatingUser, error, putJson } = useHttpFetchApi();
  const [updatedUser, setUpdatedUser] = useState<User | undefined>();
  const updateUser = useCallback(
    async (user: Partial<User>) => {
      const response = await putJson<User>(`users/me`, user);
      setUpdatedUser(response);
      return response;
    },
    [putJson]
  );
  const clearUpdatedUser = useCallback(() => setUpdatedUser(undefined), []);
  useEffect(
    () =>
      void (
        !disableAlertOnError &&
        error &&
        logError('Put Current User Error', error)
      ),
    [disableAlertOnError, error, logError]
  );
  return {
    updatedUser,
    updatingUser,
    updateUserError: error,
    updateUser,
    clearUpdatedUser
  };
}
